import React from 'react'

// YouTube attribution is a compliance requirement (design.md §6 / §7 #4, brief §69).
// Inline SVG logomark keeps the footer self-contained (no external asset fetch).
function YouTubeLogo() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 28 20"
      className="inline-block h-5 w-7 align-middle"
      role="img"
    >
      <path
        fill="#FF0000"
        d="M27.4 3.1a3.5 3.5 0 0 0-2.46-2.48C22.77 0 14 0 14 0S5.23 0 3.06.62A3.5 3.5 0 0 0 .6 3.1 36.7 36.7 0 0 0 0 10a36.7 36.7 0 0 0 .6 6.9 3.5 3.5 0 0 0 2.46 2.48C5.23 20 14 20 14 20s8.77 0 10.94-.62a3.5 3.5 0 0 0 2.46-2.48A36.7 36.7 0 0 0 28 10a36.7 36.7 0 0 0-.6-6.9Z"
      />
      <path fill="#FFFFFF" d="M11.2 14.29 18.5 10l-7.3-4.29v8.58Z" />
    </svg>
  )
}

function Footer() {
  return (
    <footer className="bg-white">
      <div className="mx-auto max-w-7xl py-12 px-4 sm:px-6 md:flex md:items-center md:justify-between lg:px-8">
        <div className="flex items-center justify-center gap-2 md:order-2">
          <span className="text-base font-sans text-gray-400">Powered by</span>
          <YouTubeLogo />
          <span className="text-base font-sans text-gray-400">YouTube</span>
        </div>
        <div className="mt-8 md:order-1 md:mt-0">
          <p className="text-center text-base font-sans text-gray-400">&copy; 2022 Stream Park</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
